<template>
  <div class="main-content login">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Cari Dokter</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="login-container appointment">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-uppercase mt-0 line-height-1">
              Team Dokter Handal
              <span class="text-theme-colored">Rumah Sakit UII</span>
            </h2>
          </div>
          <div class="col-md-12">
            <form
              id="login-form"
              name="login-form"
              class="mt-30"
              method="post"
              action
              novalidate="novalidate"
            >
              <div class="row">
                <div class="col-md-12">
                  <input
                    name="email"
                    v-model="searchQuery"
                    class="form-control"
                    type="text"
                    required
                    placeholder="Cari Nama Dokter"
                    aria-required="true"
                  />
                </div>
                <div class="col-md-12">
                  <br />
                  <!-- <div class="alert alert-info">
									<i class="fa fa-info-circle"></i> Perhatikan huruf untuk pencarian <code>huruf besar</code> dan <code>huruf kecil</code> mempengaruhi pencarian
                  </div>-->
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row mt-30">
          <div class="col-md-12">
            <h5 class="text-uppercase mt-0 line-height-1">
              Hasil Pencarian Dokter
              <span class="text-theme-colored">Rumah Sakit UII</span>
            </h5>
          </div>
          <div class="col-md-12 mt-20 search-result">
            <div v-if="show_nodata" class="alert alert-danger">No data</div>
            <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            <div v-if="!show_loading" class="row clearfix team-member">
              <div
                v-bind:key="item.id"
                v-for="item in filteredResources(resources)"
                class="col-xs-12 col-sm-6 col-md-4 col-lg-4 sm-text-center mb-30 mb-sm-30"
              >
                <div class="team-members border-bottom-theme-color-2px text-center">
                  <b-link :to="{ path: '/detail-dokter/' + item.id }">
                    <div class="team-thumb">
                      <img class="img-fullwidth" alt :src="item.picture" />
                      <div class="team-overlay"></div>
                    </div>
                    <div class="team-details bg-silver-light pt-10 pb-10 pr-10 pl-10">
                      <h5 class="font-weight-600 m-5">{{ item.name.substr(0, 30) + '...' }}</h5>
                      <h6 class="font-15 font-weight-400 mt-0">{{ item.poli }}</h6>
                      <a
                        v-if="user_data != undefined && user_data.rm != '' && user_data.rm != null"
                        :href="appointment_url"
                        class="mt-5 color-white btn btn-dark btn-circled btn-default btn-sm btn-theme-colored"
                      >Buat Janji</a>
                    </div>
                  </b-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { TERRA_APPOINTMENT } from "../config/VariableComponents";
import api from "../services/api";

export default {
  data() {
    return {
      show_loading: false,
      show_nodata: false,
      searchQuery: "",
      resources: [],
      user_data: {},
      appointment_url: "#",
    };
  },
  created() {
    this.searchQuery = this.$route.params.search;
    this.slug = this.$route.params.slug;
  },
  mounted() {
    this.checkUser();
    this.getDoctors();
  },
  methods: {
    checkUser() {
      let getUserData = localStorage.getItem("user_data");
      if (getUserData != undefined) {
        this.logged = true;
        this.user_data = JSON.parse(getUserData);
        this.appointment_url = TERRA_APPOINTMENT + "?norm=" + this.user_data.rm;
      }
    },
    getDoctors() {
      this.show_loading = true;
      api
        .post(api.route.get.doctors)
        .then((res) => {
          let status = res.status;
          if (status) this.resources = res.data;
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
    filteredResources(resources) {
      if (this.searchQuery) {
        let filterResources = resources.filter((item) => {
          let name = item.name;
          let nameLower = item.name.toLowerCase();
          let poli = item.poli;
          let poliLower = poli.toLowerCase();

          return (
            name.startsWith("dr. " + this.searchQuery) ||
            name.startsWith(this.searchQuery) ||
            nameLower.startsWith("dr. " + this.searchQuery) ||
            nameLower.startsWith(this.searchQuery) ||
            name.startsWith("drg. " + this.searchQuery) ||
            name.startsWith(this.searchQuery) ||
            nameLower.startsWith("drg. " + this.searchQuery) ||
            nameLower.startsWith(this.searchQuery) ||
            poli.startsWith(this.searchQuery) ||
            poliLower.startsWith(this.searchQuery)
          );
        });

        if (filterResources.length < 1) this.show_nodata = true;
        else this.show_nodata = false;

        return filterResources;
      } else {
        this.show_nodata = false;
        return this.resources;
      }
    },
  },
  watch: {
    resources: {
      deep: true,
      immediate: true,
      handler: function (value) {
        this.filteredResources(value);
      },
    },
  },
};
</script>
<style>
.team-thumb {
  overflow: hidden;
  max-height: 180px;
}

.team-thumb img {
  border-radius: 5px 5px 0px 0px;
}

.team-details {
  border-radius: 0px 0px 5px 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/CariDokter.vue